import config from "config/config";

const urlSso = "/wizsso/api/v2";
const urlMsg = "/wizmessage/api/v2";
const urlCom = "/wizcommon/api/v2";

const urls = {
    // 로그인 중 사용
    "login": urlSso + "/auth/login",                // POST   : 자체 로그인
    "login-single": urlSso + "/auth/login/single",  // POST   : 자체 로그인 (중복 로그인 불가)
    "social-login": urlSso + "/auth/social",        // POST   : SNS 토큰으로 로그인
    "social-login-single": urlSso + "/auth/social/single", // POST : SNS 토큰으로 로그인 (중복 로그인 불가)
    "refresh": urlSso + "/auth/refresh",            // POST   : Access Token 갱신

    // 회원가입 중 사용
    "check-duplicate-input": urlSso + "/auth/signup/duplicate/input", // GET : 회원 가입 중 입력 시 중복 실시간 조회
    "check-duplicate-account": urlSso + "/auth/signup/duplicate/account", // POST : 회원 가입 중 가입 시 전화번호(민감정보라 POST) 중복 조회
    "signup": urlSso + "/auth/signup",                          // POST   : 일반 및 SNS 회원가입
    "signup-policy": urlSso + "/auth/signup-policy",            // POST   : 가입 연령 정책 판정 (생년월일 — 민감정보라 POST)
    "terms-list": urlCom + "/terms/active/",                    // GET    : 약관 전체 목록 조회
    "terms-detail": urlCom + "/terms/",                         // GET    : 약관 상세 조회

    // 회원탈퇴
    "withdraw": urlSso + "/auth/withdraw/hard",                 // DELETE : 회원탈퇴 (Hard delete)

    // 아이디·비밀번호 찾기
    "find-account": urlSso + "/auth/find-account",              // POST   : 본인인증 결과로 가입 계정 조회
    "reset-password": urlSso + "/auth/reset-password",          // POST   : recoveryToken 으로 비밀번호 재설정

    // 인증 관련
    "send-verify-code": urlMsg + "/sms/verify/send",            // POST   : 인증 SMS 발송 (해외 OTP)
    "check-verify-code": urlSso + "/verify/check-by-id",        // POST   : 인증 코드 검증 (해외 OTP)

    // 다날 본인인증 (포트원 V2 프록시)
    "portone-send": urlSso + "/verify/portone/send",            // POST   : 다날 OTP SMS 발송
    "portone-confirm": urlSso + "/verify/portone/confirm",      // POST   : 다날 OTP 확인 + CI/DI 반환

    // TODO. 아이디/비밀번호 찾기
}

export const getApiUrl = (name: keyof typeof urls) => {
    return config.API_URL + urls[name];
}
